import { User } from "./types";
import classes from "./styles.module.scss";

interface Props {
  user?: User | null;
}
const ProfileImageByUser = ({ user }: Props) => {
  return <div className={classes.profileImage}>{user?.first_name?.[0] || ""}</div>;
};

export default ProfileImageByUser;
